const EyeIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0002 9.38867C10.2752 9.38867 8.8877 10.7762 8.8877 12.5012C8.8877 14.2262 10.2752 15.6137 12.0002 15.6137C13.7252 15.6137 15.1127 14.2262 15.1127 12.5012C15.1127 10.7762 13.7252 9.38867 12.0002 9.38867ZM12.0002 13.9262C11.2127 13.9262 10.5752 13.2887 10.5752 12.5012C10.5752 11.7137 11.2127 11.0762 12.0002 11.0762C12.7877 11.0762 13.4252 11.7137 13.4252 12.5012C13.4252 13.2887 12.7877 13.9262 12.0002 13.9262Z"
        fill="currentColor"
      />
      <path
        d="M22.95 11.1879C20.8125 8.00039 17.85 4.77539 12 4.77539C6.15 4.77539 3.1875 8.00039 1.05 11.1879C0.525 11.9754 0.525 13.0254 1.05 13.8129C3.1875 16.9629 6.15 20.2254 12 20.2254C17.85 20.2254 20.8125 16.9629 22.95 13.8129C23.475 12.9879 23.475 11.9754 22.95 11.1879ZM21.5625 12.8754C18.825 16.8879 16.0875 18.5379 12 18.5379C7.9125 18.5379 5.175 16.8879 2.4375 12.8754C2.2875 12.6504 2.2875 12.3504 2.4375 12.1254C5.175 8.11289 7.9125 6.46289 12 6.46289C16.0875 6.46289 18.825 8.11289 21.5625 12.1254C21.675 12.3504 21.675 12.6504 21.5625 12.8754Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EyeIcon;
